export default __webpack_public_path__ + "static/media/empty.4c275c67.png";